export default "__VITE_PUBLIC_ASSET__a37c368d__"